<template>
	<NuxtRouteAnnouncer />
	<NuxtLoadingIndicator color="#155E75" />
	<NuxtUiApp :locale="ru">
		<NuxtPage />
	</NuxtUiApp>
</template>

<script setup lang="ts">
import { ru } from '@nuxt/ui/locale'

const _user = useAuth()

const router = useRouter()
const { createModal } = useConfirmation()

createModal('exit', {
	title: 'Вы уверены?', 
	description: 'Все несохраненные данные будут потеряны', 
	confirmButtonText: 'Выйти',
	color: 'error', 
	onConfirmFn: () => router.back()
})

const errorState = useState('error')

onMounted(()=> {
	if (errorState.value) {
        useToastError(errorState.value)
    }
})

// console.warn(useRuntimeConfig().public.apiUrl)
</script>